
        import type { TemplateResult, TemplateRootPropsForTag } from 'Components/types';
type garageRTRootProps = TemplateRootPropsForTag<'div'>;
import { createElement as _createElement } from 'preact';
import { map as _map } from 'Utils/array';
import _translate from 'Utils/translate';
export default function garageRT(): TemplateResult<garageRTRootProps> {
    return _createElement('div', { 'className': 'cm_garage' }, _createElement('a', {
        'className': 'cm_toggle-dropdown garage-button',
        'title': 'Garage: ' + this.size + ' item(s)',
        'tabIndex': '0',
        'role': 'button'
    }, _createElement('div', { 'className': 'garage-icon-container' }, [_createElement('span', {
            'className': 'icon icon-garage inline-flex',
            'key': '1740'
        }, _createElement('svg', {
            'width': '23',
            'height': '18',
            'viewBox': '0 0 23 18',
            'fill': 'none',
            'xmlns': 'http://www.w3.org/2000/svg'
        }, _createElement('path', {
            'd': 'M21.5045 15.5537H20.7638V6.9129C20.7638 6.66911 20.7037 6.4291 20.5887 6.21414C20.4737 5.99918 20.3074 5.81592 20.1046 5.68062L11.9574 0.248776C11.7141 0.0865614 11.4282 0 11.1357 0C10.8433 0 10.5574 0.0865614 10.3141 0.248776L2.16682 5.68062C1.96386 5.81581 1.79741 5.99902 1.68226 6.21399C1.5671 6.42896 1.5068 6.66903 1.50671 6.9129V15.5537H0.766049C0.569614 15.5537 0.381225 15.6317 0.242324 15.7706C0.103424 15.9095 0.0253906 16.0979 0.0253906 16.2943C0.0253906 16.4908 0.103424 16.6792 0.242324 16.8181C0.381225 16.957 0.569614 17.035 0.766049 17.035H21.5045C21.7009 17.035 21.8893 16.957 22.0282 16.8181C22.1671 16.6792 22.2451 16.4908 22.2451 16.2943C22.2451 16.0979 22.1671 15.9095 22.0282 15.7706C21.8893 15.6317 21.7009 15.5537 21.5045 15.5537ZM2.98802 6.9129L11.1353 1.48106L19.2825 6.91197V15.5537H17.0605V10.369C17.0605 10.1726 16.9825 9.98419 16.8436 9.84529C16.7047 9.70639 16.5163 9.62835 16.3199 9.62835H5.95066C5.75422 9.62835 5.56583 9.70639 5.42693 9.84529C5.28803 9.98419 5.21 10.1726 5.21 10.369V15.5537H2.98802V6.9129ZM15.5792 11.1097V12.591H11.8759V11.1097H15.5792ZM10.3946 12.591H6.69132V11.1097H10.3946V12.591ZM6.69132 14.0723H10.3946V15.5537H6.69132V14.0723ZM11.8759 14.0723H15.5792V15.5537H11.8759V14.0723Z',
            'fill': '#262626'
        })))], this.size ? _createElement('span', {
        'className': 'garage-size',
        'key': '1626'
    }, this.size) : null), _createElement('span', { 'className': 'garage-label' }, _translate(`garage_title`))), [this.garageDropdown(function () {
            function repeatItems1(items, itemsIndex) {
                return [items(function () {
                        return _createElement('div', { 'className': 'garage-item' }, _createElement('span', {
                            'className': 'select-model',
                            'onClick': this.selectVehicle
                        }, this.vehicleString), _createElement('span', {
                            'className': 'remove-model',
                            'onClick': this.removeVehicle
                        }, [_createElement('svg', {
                                'className': 'cm_icon cm_icon-times',
                                'height': '20px',
                                'role': 'img',
                                'viewBox': '0 0 22 22',
                                'key': '1930'
                            }, _createElement('path', { 'd': 'M1,1L21,21M21,1L1,21' }))]));
                    }, { count: undefined })];
            }
            return _createElement('div', { 'className': 'cm_garageDropdown' }, this.template === 'list' ? _createElement('div', {
                'className': 'cmTemplate_list',
                'key': '31'
            }, _createElement('div', { 'className': 'garage-content' }, _createElement('div', {
                'className': 'clear-garage',
                'onClick': this.clearGarage
            }, _translate(`garage_clear`)), _createElement.apply(this, [
                'div',
                { 'className': 'cmRepeater_items' },
                _map(this.items, repeatItems1.bind(this))
            ]), [this.addButton(function () {
                    return _createElement('div', { 'className': 'add-vehicle  cm_button cm_button__primary cm_addButton' }, [window.Convermax.config?.garageButtonText || _translate(`garage_add_button`)]);
                }, {
                    widgetName: 'undefined',
                    items: undefined
                })])) : null, this.template === 'empty' ? _createElement('div', {
                'className': 'cmTemplate_empty',
                'key': '1408'
            }, _createElement('div', { 'className': 'garage-content' }, [this.addButton(function () {
                    return _createElement('div', { 'className': 'add-vehicle  cm_button cm_button__primary cm_addButton' }, [window.Convermax.config?.garageButtonText || _translate(`garage_add_button`)]);
                }, {
                    widgetName: 'undefined',
                    items: undefined
                })], _createElement('ul', {}, _createElement('li', { 'className': 'vehicle-advantages' }, _translate(`garage_info_line_one`)), _createElement('li', { 'className': 'vehicle-advantages' }, _translate(`garage_info_line_two`)), _createElement('li', { 'className': 'vehicle-advantages' }, _translate(`garage_info_line_three`))))) : null);
        }, {
            widgetName: 'undefined',
            items: undefined
        })]);
}
        export const componentNames = ["cm:addButton","cm:addButton","cm:garageDropdown"]